export default __webpack_public_path__ + "static/media/cage-dots.80d5d92a.svg";